<div class="treeslo-detail">
    <div class="treeslo-detail-header">
        <h4 class="d-flex align-items-center gap-2">
            <i-tabler name="eye" class="icon-18 me-2"></i-tabler>
            {{ titleKey | translate }}
        </h4>
        <div class="treeslo-detail-header__actions">
            <ng-content select="[row-details-actions]" />
        </div>
    </div>
    <ng-content />
</div>
